var path = 'areas/environments/views/endpoints/azure_web_app_endpoint.html';
var html = "<div> <control-group label=Account> <account-selector endpoint=endpoint type=AzureSubscription></account-selector> </control-group> <azure-web-site-selector-deprecated endpoint=endpoint></azure-web-site-selector-deprecated> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/views/endpoints/azure_web_app_endpoint.html
// module id = 784
// module chunks = 1